module.exports = __webpack_public_path__ + "6694b7bddf4e2df31af543fb1d4cc5f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/gears5/vasgar.png
// module id = 1069
// module chunks = 0